"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyQuery = exports.parseSearchParams = void 0;
const qs_1 = require("qs");
const parseSearchParams = (searchParams, parseOptions) => (0, qs_1.parse)(searchParams.toString(), parseOptions !== null && parseOptions !== void 0 ? parseOptions : {
    ignoreQueryPrefix: true,
});
exports.parseSearchParams = parseSearchParams;
const stringifyQuery = (query, stringifyOptions) => (0, qs_1.stringify)(query, stringifyOptions !== null && stringifyOptions !== void 0 ? stringifyOptions : {
    encodeValuesOnly: true,
    skipNulls: true,
});
exports.stringifyQuery = stringifyQuery;
//# sourceMappingURL=utils.js.map